const makeInitialState = data => ({
  ...data,
  id: data ? data.id : '',
  name: data ? data.name : '',
  value: data ? data.value : ''
});

export default makeInitialState;
